import React, { forwardRef } from 'react';
import Radio from '../../atoms/Radio';
import { useRadioGroup } from './useRadioGroup';
const RadioOption = forwardRef(function RadioOption({ label, value, children, testId = 'store-radio-option', ...otherProps }, ref) {
    const { name, selectedValue, onChange } = useRadioGroup();
    return (React.createElement("label", { "aria-label": label, "data-fs-radio-option": true },
        React.createElement(Radio, Object.assign({ "data-fs-radio-option-item": true, ref: ref, name: name, checked: value === selectedValue, onChange: onChange, value: value, testId: testId }, otherProps)),
        children));
});
export default RadioOption;
//# sourceMappingURL=RadioOption.js.map